import { FC } from 'react';
import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import {
  Button,
  usePopoverDialog,
  useControlledField,
  Text,
  PopoverDialog,
  ChecklistField,
} from '@frontend/design-system';
import { useTaskCenterStore } from '../../provider';
import { filtersButtonStyle } from './common-styles';

interface TaskLocationFilterProps {
  selectedLocations: string[];
  setSelectedLocations: (value: string[]) => void;
}

export const TaskLocationFilter: FC<TaskLocationFilterProps> = ({ selectedLocations, setSelectedLocations }) => {
  const { t } = useTranslation('task-center');
  const { getDialogProps, getTriggerProps } = usePopoverDialog();
  const { locationsData } = useTaskCenterStore(['locationsData']);
  const sourceFiledProps = useControlledField({
    type: 'checklist',
    value: selectedLocations,
    onChange: (value) => setSelectedLocations(value),
    minRequired: 1,
  });

  if (locationsData.length == 1) return null;

  return (
    <span>
      <Button css={filtersButtonStyle} {...getTriggerProps()}>
        <Icon name='location' />
        <Text>{t('Location')}</Text>
        <Icon name='alt-caret-right-tiny' color='subdued' css={marginLeftAuto} />
      </Button>
      <PopoverDialog {...getDialogProps()}>
        <ChecklistField label={''} name='' {...sourceFiledProps}>
          {locationsData.map((location) => {
            const selectedOption = sourceFiledProps.value.includes(location.id);
            const isSingleOptionSelected = !!selectedOption && sourceFiledProps.value.length === 1;
            return (
              <ChecklistField.Option
                key={`task-location-filter-item-${location.id}`}
                name={location.id}
                disabled={isSingleOptionSelected}
              >
                {location.name}
              </ChecklistField.Option>
            );
          })}
        </ChecklistField>
      </PopoverDialog>
    </span>
  );
};

export const marginLeftAuto = css`
  margin-left: auto;
`;
